import { Box } from "@mui/material";
import { DotLegalButton, DotLegalHeader } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "@localization/useTranslation";
import { publicRiskObservationStyles as styles } from "../PublicRiskObservation.styles";

export interface ISuccessStepProps {
    name: string;
    sourceName: string;
    observedBy: string;
    observedByEmail: string;
    onSendAnother: () => void;
    onDone: () => void;
}

function SuccessStep(props: ISuccessStepProps) {
    const { translateString } = useTranslation();

    const summaryRows = [
        { label: translateString("reportObservationNameLabel"), value: props.name },
        { label: translateString("source"), value: props.sourceName },
        { label: translateString("name"), value: props.observedBy },
        { label: translateString("email"), value: props.observedByEmail },
    ];

    return (
        <>
            <Box sx={styles.content}>
                <Box sx={styles.successMarker} aria-hidden>
                    ✓
                </Box>
                <DotLegalHeader headerStyle="xxl" center marginBottom={0}>
                    {translateString("reportObservationSuccessHeader")}
                </DotLegalHeader>
                <DotLegalHeader headerStyle="small" fontWeight={400} center marginBottom={0}>
                    {translateString("reportObservationSuccessText")}
                </DotLegalHeader>
                <Box sx={styles.summaryCard}>
                    {summaryRows.map((row) => (
                        <Box key={row.label} sx={styles.summaryRow}>
                            <DotLegalHeader headerStyle={"small"} marginBottom={0} fontWeight={400}>
                                {row.label}
                            </DotLegalHeader>
                            <DotLegalHeader headerStyle={"small"} marginBottom={0}>
                                {row.value}
                            </DotLegalHeader>
                        </Box>
                    ))}
                </Box>
            </Box>
            <Box sx={styles.footer}>
                <DotLegalButton buttonType="secondary" size="medium" onClick={props.onSendAnother}>
                    {translateString("reportObservationSendAnother")}
                </DotLegalButton>
                <Box sx={styles.footerPrimary}>
                    <DotLegalButton buttonType="primary" size="medium" fullWidth onClick={props.onDone}>
                        {translateString("reportObservationDone")}
                    </DotLegalButton>
                </Box>
            </Box>
        </>
    );
}

export default SuccessStep;
